// extracted by mini-css-extract-plugin
export default {"numberSelect":"CountChooser_numberSelect__epPGW","input":"CountChooser_input__oKmBw"};